export default __webpack_public_path__ + "a95dd77b883e49e76dbc820e5227723d.svg";